import { TAction, TDispatch } from "../../../types";
import {
  SuratKeteranganAction,
  SuratKeteranganActionType,
  SuratKeteranganModel,
} from "./types";
import { fetchAPI } from "../../../../config/axios";
import { AxiosResponse } from "axios";

export const SuratKeteranganDefault: SuratKeteranganModel = {
  main: {
    data: [],
    total: 0,
  },
  notification: {
    data: [],
  },
  detail: {
    data: {} as any,
  },
};

export const SuratKeteranganReducer = (
  state: SuratKeteranganModel = SuratKeteranganDefault,
  action: SuratKeteranganAction
): SuratKeteranganModel => {
  switch (action.type) {
    case SuratKeteranganActionType.GetAllSuratKeterangan:
      return { ...state, main: action.data };
    case SuratKeteranganActionType.GetDetailSuratKeterangan:
      return { ...state, detail: action.data };
    case SuratKeteranganActionType.GetHistoryNotification:
      return { ...state, notification: action.data };
    default:
      return { ...state };
  }
};

export const SuratKeteranganCommand = {
  GetAllSuratKeterangan: (params?: unknown): TAction<SuratKeteranganAction, void> => {
    return (dispatch: TDispatch<SuratKeteranganAction>) => {
      return fetchAPI()
        .get("/surat-sk", { params: params })
        .then((response) => {
          dispatch({
            data: {
              data: response.data.data.data,
              total: response.data.data.total,
            },
            type: SuratKeteranganActionType.GetAllSuratKeterangan,
          });
        });
    };
  },
  GetDetailSuratKeterangan: (
    params?: unknown
  ): TAction<SuratKeteranganAction, void> => {
    return async (dispatch: TDispatch<SuratKeteranganAction>) => {
      try {
        const response = await fetchAPI().get("/surat-sk", {
          params: params,
        });
        dispatch({
          data: {
            data: response.data.data,
          },
          type: SuratKeteranganActionType.GetDetailSuratKeterangan,
        });
      } catch (error) {
        throw error;
      }
    };
  },
  CreateSuratKeterangan: (
    body?: any
  ): TAction<SuratKeteranganAction, AxiosResponse<any, any>> => {
    return async (dispatch: TDispatch<SuratKeteranganAction>) => {
      try {
        const response = await fetchAPI().post("/surat-sk", body);
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  UpdateSuratKeterangan: (
    body: any
  ): TAction<SuratKeteranganAction, AxiosResponse<any, any>> => {
    return async (dispatch: TDispatch<SuratKeteranganAction>) => {
      try {
        const response = await fetchAPI().post("/update-surat-sk", body);
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  DeleteSuratKeterangan: (
    body: any
  ): TAction<SuratKeteranganAction, AxiosResponse<any, any>> => {
    return async (dispatch: TDispatch<SuratKeteranganAction>) => {
      try {
        const response = await fetchAPI().delete("/delete-surat-sk", { data: body });
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  GetHistoryNotification: (params?: unknown): TAction<SuratKeteranganAction, void> => {
    return (dispatch: TDispatch<SuratKeteranganAction>) => {
      return fetchAPI()
        .get("/notifications", { params: params })
        .then((response) => {
          dispatch({
            data: {
              data: response.data.data.data,
            },
            type: SuratKeteranganActionType.GetHistoryNotification,
          });
        });
    };
  },
  MarkAsReadNotification: (
    body?: any
  ): TAction<SuratKeteranganAction, AxiosResponse<any, any>> => {
    return async (dispatch: TDispatch<SuratKeteranganAction>) => {
      try {
        const response = await fetchAPI().patch("/notification/read", body);
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  MarkAllAsReadNotification: (
    body?: any
  ): TAction<SuratKeteranganAction, AxiosResponse<any, any>> => {
    return async (dispatch: TDispatch<SuratKeteranganAction>) => {
      try {
        const response = await fetchAPI().patch("/notification/mark-all-read", body);
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
};
